type TStatus = "DATA_INIT" | "DATA_PENDING" | "DATA_SUCCESS" | "DATA_ERROR";
export const DATA_INIT = "DATA_INIT";
export default TStatus;
